import { render } from "./AppHeader.vue?vue&type=template&id=20787342&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=20787342&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20787342"

export default script